import { CallType } from 'features/call/call-base/enums';

/* This can be unified with the VRS version when we simplify the VRS call type enum */
export const shouldShowLeaveQueueButtonVri = (
  callType: CallType | null
): boolean => {
  if (!callType) {
    return true;
  }
  const isEmergencyCallType = callType === CallType.EMERGENCY_CALL;
  if (isEmergencyCallType) {
    return false;
  }

  const isColdHandoff = callType === CallType.COLD_HANDOFF_CALL;
  if (isColdHandoff) {
    return true;
  }

  const isRegularCall = callType === CallType.REGULAR_CALL;
  if (isRegularCall) {
    return true;
  }

  const isTeamingRegularCall = callType === CallType.TEAMING_REGULAR_CALL;
  if (isTeamingRegularCall) {
    return true;
  }

  const isConferenceOrTeamingConference =
    callType === CallType.CONFERENCE_CALL ||
    callType === CallType.TEAMING_CONFERENCE_CALL;
  if (isConferenceOrTeamingConference) {
    return true;
  }

  return false;
};
